// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0b8c81ba","171":"52f878ce"}[chunkId] + ".chunk.js";
};